import ihm from './InHouseMethod/Config';

export default {
  ...ihm,
};
